import useIsRegistrationDisabled from "@casino/client/hooks/useIsRegistrationDisabled";
import useAuthTabSwitch from "@casino/legacy/client/components/Auth/Shared/useAuthTabSwitch";
import useLink from "@casino/legacy/client/components/Auth/Shared/useLink";
import Translate from "@casino/legacy/client/shared/i18n/Translate";
import NextLink from "@casino/legacy/client/shared/NextLink";
import { useRouter } from "next/navigation";
import CreateAccountLinkBody from "./CreateAccountLinkBody";

type Props = {
  isPopover?: boolean;
};
const CreateAccountLink: FC<Props> = ({ isPopover }) => {
  const { href } = useLink("register");
  const switchTab = useAuthTabSwitch();
  const router = useRouter();
  const isRegistrationDisabled = useIsRegistrationDisabled();

  if (isRegistrationDisabled) {
    return null;
  }
  if (isPopover) {
    return (
      <CreateAccountLinkBody>
        <div
          className="cursor-pointer text-primary"
          onClick={() => switchTab("register")}
        >
          <Translate id="profile.create_account" />
        </div>
      </CreateAccountLinkBody>
    );
  }
  return (
    <CreateAccountLinkBody>
      <NextLink href={href} onTouchEnd={() => router.replace(href.pathname)}>
        <p className="text-sm leading-6 text-primary">
          <Translate id="profile.create_account" />
        </p>
      </NextLink>
    </CreateAccountLinkBody>
  );
};

export default CreateAccountLink;
